import { Delete, ExitToApp, NoteAdd, Print, Save } from '@mui/icons-material';
import React, { Fragment, memo, useEffect, useState } from 'react';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setPDFData } from '../../../../../components/hooks/printPdf/pdfData';
import { Button, Stack, Typography, Backdrop, CircularProgress } from '@mui/material';
import DeletePage from '../../../../../components/utils/deleteModal/deletePage';
import DialogCancel from '../../../../../components/utils/dialogCancel/dialogCancel';

const CustomerInfo = ({ data, setData, postData, setPostData, docName, outletId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSaving, setIsSaving] = useState(false);
  const [dialogClose, setDialogClose] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state added
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  let totalAmt = 0;
  totalAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.totalAmt), 0);
  let gstAmt = 0;
  gstAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.gstAmt), 0);
  let cessAmt = 0;
  cessAmt += data.reduce((accumulator, item) => accumulator + parseFloat(item.cessAmt), 0);
  let netTotal = 0;
  netTotal = parseFloat(totalAmt + gstAmt).toFixed(2);

  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

  const convertNumber = (num) => {
    if (num === 0) return 'Zero';

    let words = '';
    for (let i = 0; num > 0; i++) {
      if (num % 1000 !== 0) {
        words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
      }
      num = Math.floor(num / 1000);
    }
    return words.trim();
  };

  const convertHundreds = (num) => {
    if (num >= 100) {
      return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
    } else {
      return convertTens(num);
    }
  };

  const convertTens = (num) => {
    if (num < 10) return units[num];
    else if (num < 20) return teens[num - 10];
    else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
  };

  const cancelTransaction = () => {
    const postData = {
      outlet_id: outletId,
      docno: docName,
    };
    axios
      .post(`/v1/issue_transfer_temp/cancel`, postData)
      .then((res) => {
        dispatch(setSnackbar(true, 'success', 'Deleted successfully!'));
        setData([]); // Clear the data if needed
        setOpenDeleteDialog(false);
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(
            true,
            'error',
            err.response?.data?.errors[0]?.message || 'Failed to cancel transaction'
          )
        );
      });
  };

  const onClickCancel = () => {
    setDialogClose(false);
  };
  const onClickExit = () => {
    navigate('/');
  };
  const handleExit = () => {
    setDialogClose(true);
  };

  function handleSubmit() {
    if (totalAmt > 49000) {
      dispatch(setSnackbar(true, 'error', 'Total purchase value cannot exceed ₹49,000'));
      return;
    }
    if (postData.partycode === '0') {
      dispatch(setSnackbar(true, 'error', 'Please select Outlet Name'));
      return;
    }
    if (postData.sales_details.length === 0) {
      dispatch(setSnackbar(true, 'error', 'Please fill barcode & Click enter to save'));
      return;
    }
    setLoading(true);
    axios
      .post('/v1/sales_master', postData)
      .then((res) => {
        dispatch(setSnackbar(true, 'success', 'Issue / Transfer successfully processed!'));
        fetchBill();
        console.log('saved mult');
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(true, 'error', err.response?.data?.errors?.message || 'Failed to save')
        );
      })
      .finally(() => {
        setLoading(false);
        console.log('done');
      });
  }

  const tableData = data.map((val) => ({
    pro_name: val.pro_name,
    hsn: val.hsn,
    sale_rate: val.sale_rate,
    pur_rate: val.pur_rate,
    qty: val.qty,
    disc1: val.disc1,
    cgstPerc: val.gst,
    cgstAmnt: val.gstAmt,
    totalAmt: val.totalAmt,
    mode: val.mode,
  }));

  const TotalData = {
    sub_total: totalAmt,
    gst: gstAmt,
    totalAmount: parseFloat(Math.round(netTotal)).toFixed(0),
    roundOff: (Math.round(netTotal) - netTotal).toFixed(2),
    totalText: convertNumber(Math.round(netTotal)),
  };

  function fetchBill() {
    axios
      .post(`/v1/sales_master/getall`, { docno: docName })
      .then((res) => {
        dispatch(
          setPDFData({
            tableData: tableData,
            TotalData: TotalData,
            companyInfo: res.data,
            totalText: convertNumber(Math.round(netTotal)),
            title: postData.mode === 'Transfer' ? 'Delivery Challan' : 'Tax Invoice',
            companyname: 'S R Enterprises',
          })
        );
        const name = `BillNo_${docName}`;
        navigate(`/invoices/${name}`);
      })
      .catch((err) => {
        console.log(err);
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message));
      });
  }

  useEffect(() => {
    setPostData((prevState) => ({
      ...prevState,
      amount: Math.round(netTotal),
      cess_amt: cessAmt,
      subtotal_amount: parseFloat(totalAmt).toFixed(0),
      gst_amt: gstAmt,
      roff: (Math.round(netTotal) - netTotal).toFixed(2),
    }));
  }, [data]);

  return (
    <Fragment>
      <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }}>
        Total
      </Typography>
      <div className="flex p-1">
        <Typography
          textAlign="right"
          sx={{ paddingRight: 0.4, fontWeight: 600, fontSize: 36, width: '100%' }}
        >
          {Math.round(parseFloat(totalAmt + gstAmt)).toFixed(0)}
        </Typography>
      </div>
      <div className="my-2">
        <Typography variant="h6" textAlign="center" mb={2} sx={{ backgroundColor: "#83A2FF" }}>
          Summary
        </Typography>

        <Stack spacing={1} sx={{ my: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body1" fontWeight={600}>
              Taxable Value
            </Typography>
            <Typography variant="h6" fontWeight={600} sx={{ fontSize: 20 }}>
              {totalAmt.toFixed(2)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body1" fontWeight={600}>
              GST Amt
            </Typography>
            <Typography variant="h6" fontWeight={600} sx={{ fontSize: 20 }}>
              {gstAmt.toFixed(2)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body1" fontWeight={600}>
              Round Off
            </Typography>
            <Typography variant="h6" fontWeight={600} sx={{ fontSize: 20 }}>
              {parseFloat(TotalData.roundOff)}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body1" fontWeight={600}>
              Net Total
            </Typography>
            <Typography variant="h6" fontWeight={600} sx={{ fontSize: 20 }}>
              {Math.round(netTotal)}
            </Typography>
          </Stack>
        </Stack>
      </div>
      <Stack>
        <Button size="small" sx={{ margin: 1 }} startIcon={<Delete />} variant="outlined" onClick={() => setOpenDeleteDialog(true)}>
          Cancel
        </Button>
        <Stack>
          <Button
            size="small"
            sx={{ margin: 1 }}
            startIcon={isSaving ? null : <Save />}
            variant="outlined"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </Stack>
        <Button size="small" sx={{ margin: 1 }} startIcon={<ExitToApp />} variant="outlined" onClick={handleExit}>
          Exit
        </Button>
      </Stack>
      <DialogCancel
        onClickCancel={onClickCancel}
        onClickExit={onClickExit}
        dialogClose={dialogClose}
        setDialogClose={setDialogClose}
      />
      <Backdrop open={openDeleteDialog} sx={{ zIndex: 1350 }} onClick={() => setOpenDeleteDialog(false)}>
        <DeletePage onCancel={setOpenDeleteDialog} onSubmit={cancelTransaction} />
      </Backdrop>
    </Fragment>
  );
};

export default memo(CustomerInfo);
